import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { useAuthStore } from '../store/authStore';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../components/Card';
import Button from '../components/Button';
import Input from '../components/Input';
import { Sparkles } from 'lucide-react';

export default function Register() {
  const navigate = useNavigate();
  const register = useAuthStore(state => state.register);
  const [isLoading, setIsLoading] = useState(false);
  const { register: formRegister, handleSubmit, formState: { errors }, watch } = useForm();

  const password = watch('password');

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      await register(data.email, data.password, data.full_name);
      toast.success('Регистрация успешна');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Ошибка регистрации');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-lg shadow-blue-500/30 mb-4">
            <Sparkles className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2">
            Chatbot Constructor
          </h1>
          <p className="text-slate-600 text-sm">Создавайте умных чат-ботов легко</p>
        </div>
        
        <Card className="w-full shadow-xl shadow-slate-200/50 border-slate-200/60 backdrop-blur-sm bg-white/80">
        <CardHeader className="space-y-2 pb-4">
          <CardTitle className="text-center text-xl">Регистрация</CardTitle>
          <CardDescription className="text-center text-sm">
            Создайте аккаунт для начала работы
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2">Полное имя</label>
              <Input
                type="text"
                {...formRegister('full_name', { required: 'Имя обязательно' })}
                error={errors.full_name?.message}
                placeholder="Иван Иванов"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Email</label>
              <Input
                type="email"
                {...formRegister('email', { required: 'Email обязателен' })}
                error={errors.email?.message}
                placeholder="user@example.com"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-2">Пароль</label>
              <Input
                type="password"
                {...formRegister('password', {
                  required: 'Пароль обязателен',
                  minLength: { value: 6, message: 'Минимум 6 символов' }
                })}
                error={errors.password?.message}
                placeholder="••••••••"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Подтвердите пароль</label>
              <Input
                type="password"
                {...formRegister('confirm_password', {
                  required: 'Подтверждение пароля обязательно',
                  validate: value => value === password || 'Пароли не совпадают'
                })}
                error={errors.confirm_password?.message}
                placeholder="••••••••"
              />
            </div>

            <Button type="submit" className="w-full" disabled={isLoading}>
              {isLoading ? 'Регистрация...' : 'Зарегистрироваться'}
            </Button>

            <p className="text-center text-sm text-muted-foreground">
              Уже есть аккаунт?{' '}
              <Link to="/login" className="text-primary hover:underline">
                Войти
              </Link>
            </p>
          </form>
        </CardContent>
      </Card>
      </div>
    </div>
  );
}
